import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { mergeProps, useButton, useFocusRing } from "react-aria";
//#region src/DatePicker/components/Calendar/Button.tsx
function CalendarButton(props) {
	const { className, isDisabled, ...buttonOptions } = props;
	const ref = React.useRef(null);
	const { buttonProps } = useButton(props, ref);
	const { focusProps, isFocusVisible } = useFocusRing();
	return /* @__PURE__ */ jsx("button", {
		...mergeProps(buttonProps, focusProps),
		ref,
		className: cn("rounded-lg p-2 outline outline-2 outline-transparent", isDisabled && "text-neutrals-60", isFocusVisible && "outline-system-info-70", className),
		children: buttonOptions.children
	});
}
//#endregion
export { CalendarButton };

//# sourceMappingURL=Button.js.map